import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation SetNameOfUserMutation($input: setNameOfUserInput!) {
    setNameOfUser(input: $input) {
      user {
        id
        pid
        name
        picture
        email
        lastActive
        createdAt
        uniqueId
        status
      }
      clientMutationId
    }
  }
`;
export default function setNameOfUser(environment, mutationVariables, onCompleted, onError) {
  const variables = {
    input: {
      ...mutationVariables,
      clientMutationId: '123'
    }
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted:
      onCompleted
      || ((response, errors) => {
        console.log('Response received from server.', response, errors);
      }),
    onError: onError || (err => console.error(err))
  });
}
